export interface IGameIntroductionRequest {
  icon: string | null;
  appName: string;
  coverImage: string | null;
  title: string;
  type: 'nouknow' | 'cogevo';
  attachments?: any;
}

export interface ICreateGameIntroductionRequest
  extends IGameIntroductionRequest {}

export interface IUpdateGameIntroductionRequest
  extends IGameIntroductionRequest {}

export enum EGameIntroductionType {
  NOUNOW = 'NOUNOW',
  COGEVO = 'COGEVO',
}

export interface IGameIntroductionBody {
  appName: string;
  iconImageUrl: string | null;
  coverImageUrl: string | null;
  title: string;
  type: EGameIntroductionType;
  isActive: boolean;
}

export type GameIntroductionFormValues = {
  title: string;
  appName: string;
  type: EGameIntroductionType;
  icon: string | null;
  cover: string | null;
  iconAttachments: any;
  coverAttachments: any;
  iconAttachment?: any;
  coverAttachment?: any;
};
